const moment = require("moment");
exports.userModel = () => {
    return {
        endpoint: 'signup',
        loginId: "",
        currentPassword: "",
        password: "",
        rePassword: "",
        name: "",
        email: "",
        cell: "",
        userType: "", // 회원유형 (의사/약사)
        hospital: "", // 병원,약국명
        hospitalAddr: "", // 병원,약국주소
        majors: "", // 진료과
        manager: "", // 담당자
        mrCode: "", // 가입코드(면허번호)
        agreeAll: false,
        agreePolicy: false,// 개인정보 수집 이용동의
        agreeTerms: false, // 이용 약관동의
        marketing: false, // 마켓팅 동의
        roleType: 'ROLE_USER'
    };
};

exports.userSampleModel = () => {
    return {
        endpoint: 'signup',
        loginId: "01099990000",
        password: "1234!@#$ab",
        rePassword: "1234!@#$ab",
        name: "구구",
        email: "t001@predict.kr",
        cell: "01099990000",
        userType: "",
        hospital: "성모병원", // 병원,약국명
        hospitalAddr: "", // 병원,약국주소
        majors: "", // 진료과
        manager: "", // 담당자
        mrCode: "123456",
        agreeAll: false,
        agreePolicy: true,// 개인정보 수집 이용동의
        agreeTerms: true, // 이용 약관동의
        marketing: false, // 마케팅 동의
        uploadFiles: [],
        roleType: 'ROLE_USER'
    };
};

exports.visitData = () =>{
  return {
        endpoint: 'signup',
        name: "",
        phone: "",
        hospital: "", // 병원,약국명
        hospitalAddr: "", // 병원,약국주소
        product: "", // 문의제품
        contents: "", // 내용
  }
}

exports.reqDataModel = () => {
    return {
        endpoint: "",
        endpointUser: "user",
        fromDay: "",
        toDay: "",
        searchVal: "",
        activated: true,
        user_id: 0,
        updUpk: 0,
        pageName: "",
        content: "",
    }
}

